import { createSlice } from "@reduxjs/toolkit";
import Enums from "../../enums";
import api from "../../Services/ApiServices";
import utils from "../../Services/Utils";
import {
  IAccountOpeningDocument,
  IAccountOpeningDocumentCancelReason,
  IAccountOpeningDocumentUploadResponse,
} from "../../Types/AOD";
import { dispatch, RootState } from "../store";

interface IDocumentUploadState {
  isLoading: boolean;
  error: any;
  lstUploadedDocument?: IAccountOpeningDocument[];
  lstDocumentCancelReasonList?: IAccountOpeningDocumentCancelReason[];
  Records2?: any[];
  IsIncomeProofMandatory?: boolean;
  IsDPClientMasterMandatory?: boolean;
  HasAnyQuery?: boolean;

  refreshLoading?: boolean;
  refreshError?: any;
}

const initialState: IDocumentUploadState = {
  isLoading: false,
  error: null,
};

const slice = createSlice({
  name: "stage4",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = undefined;
    },
    documentGetListSuccess(state, action) {
      if (action.payload.Records)
        state.lstUploadedDocument = action.payload.Records;
      if (action.payload.Records1)
        state.lstDocumentCancelReasonList = action.payload.Records1;
      if (action.payload.Records2) {
        state.Records2 = action.payload.Records2;
        if (action.payload.Records2[0]) {
          state.IsIncomeProofMandatory =
            action.payload.Records2[0].IsIncomeProofMandatory;
          state.IsDPClientMasterMandatory =
            action.payload.Records2[0].IsDPClientMasterMandatory;
          state.HasAnyQuery = action.payload.Records2[0].HasAnyQuery;
        }
      }
      state.isLoading = false;
      state.refreshLoading = false;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    refreshStartLoading(state) {
      state.refreshLoading = true;
      state.refreshError = undefined;
    },
    refreshHasError(state, action) {
      state.refreshLoading = false;
      state.refreshError = action.payload;
    },
    setLstUploadedDocument(state, action) {
      state.lstUploadedDocument = action.payload;
    },
    resetFields() {
      return { ...initialState };
    },
  },
});

// Reducer
export default slice.reducer;
export const { resetFields } = slice.actions;

export const setNewUploadedDocumentID = (
  objResponse: IAccountOpeningDocumentUploadResponse,
  AccountOpeningDocumentTypeInternalCode: number
) => {
  return async (disp: any, getState: () => RootState) => {
    try {
      const { lstUploadedDocument } = getState().stage4;
      const newLstUploadedDocument = lstUploadedDocument?.map((item) => {
        if (
          AccountOpeningDocumentTypeInternalCode ===
          item.AccountOpeningDocumentTypeInternalCode
        ) {
          return {
            ...item,
            AccountOpeningDocumentID: objResponse.AccountOpeningDocumentID,
            AccountOpeningDocumentUID: objResponse.AccountOpeningDocumentUID,
          };
        }
        return item;
      });
      await dispatch(
        slice.actions.setLstUploadedDocument(newLstUploadedDocument)
      );
    } catch (ex) {
      dispatch(slice.actions.hasError(ex));
    }
  };
};

export const getAccountOpeningDocumentList = (refresh: boolean = true) => {
  return async (disp: any, getState: () => RootState) => {
    try {
      if (refresh) await dispatch(slice.actions.refreshStartLoading());
      else await dispatch(slice.actions.startLoading());

      const { objAuthInfoResponse } = getState().common;

      let response: any = await api.GetAccountOpeningDocumentList({
        AOSAI: JSON.stringify(objAuthInfoResponse),
        ILPS: 0,
      });

      await dispatch(slice.actions.documentGetListSuccess(response));
    } catch (ex) {
      console.log(ex, "ex");
      if (refresh) await dispatch(slice.actions.refreshHasError(ex));
      else await dispatch(slice.actions.hasError(ex));
    }
  };
};

export async function checkDocumentUploadStatus(
  AODID: number,
  AODUID: string,
  onProgress?: (percent: number) => void
) {
  let maxAttempt = 5;
  let interval = 5000;
  let lastEx = null;
  let lastResponse = null;
  for (let i = 0; i < maxAttempt; i++) {
    try {
      if (onProgress) onProgress((i + 1) * (100 / maxAttempt));
      lastResponse = await api.CheckDocumentStatus({
        AODID,
        AODUID,
        PN: i + 1,
      });

      if (
        ![
          Enums.ACCOUNT_OPENING_DOCUMENT_PARSE_STATUS.PARSING_PENDING,
          Enums.ACCOUNT_OPENING_DOCUMENT_PARSE_STATUS.NONE,
        ].includes(lastResponse.AccountOpeningDocumentParseStatusInternalCode)
      ) {
        break;
      }
    } catch (ex) {
      lastEx = ex;
    }
    await utils.setTimeout(interval);
  }

  if (!lastResponse) throw lastEx;
  return lastResponse;
}
